// Mapeamento de filtros traduzidos para os valores esperados pelo backend
const FILTER_TRANSLATIONS = {
  // Filtros principais
  'todas': 'all',
  'todos': 'all',
  'a-vencer': 'expiring',
  'vencendo': 'expiring',
  'pendentes': 'pending',
  'aprovadas': 'approved',
  'em-ferias': 'taking',
  'gozando': 'taking',
  'canceladas': 'canceled',

  // Filtros de histórico
  'recusadas': 'refused',
  'coletivas': 'collective',
}

// Mapeamento das abas (tabs) traduzidas para os valores internos
const TAB_TRANSLATIONS = {
  // Abas principais
  'visao-geral': 'main',
  'historico': 'history',
}

const reverseTranslation = obj => {
  return Object.fromEntries(
    Object.entries(obj).map(([ key, value ]) => [ value, key ])
  )
}

const REVERSE_FILTER_TRANSLATIONS = reverseTranslation(FILTER_TRANSLATIONS)

const REVERSE_TAB_TRANSLATIONS = reverseTranslation(TAB_TRANSLATIONS)

/**
 * Converte um filtro traduzido (português) para o valor esperado pelo backend (inglês)
 * @param {string} translatedFilter - Filtro em português
 * @returns {string} - Filtro em inglês para o backend
 */
const translateFilterToBackend = (translatedFilter) => {
  return FILTER_TRANSLATIONS[translatedFilter] || translatedFilter
}

/**
 * Converte um filtro do backend (inglês) para o valor traduzido (português)
 * @param {string} backendFilter - Filtro em inglês do backend
 * @returns {string} - Filtro traduzido em português
 */
const translateFilterFromBackend = (backendFilter) => {
  return REVERSE_FILTER_TRANSLATIONS[backendFilter] || backendFilter
}

/**
 * Converte uma aba traduzida (português) para o valor interno (inglês)
 * @param {string} translatedTab - Aba em português
 * @returns {string} - Aba interna em inglês
 */
const translateTabToInternal = (translatedTab) => {
  return TAB_TRANSLATIONS[translatedTab] || translatedTab
}

/**
 * Converte uma aba interna (inglês) para o valor traduzido (português)
 * @param {string} internalTab - Aba interna em inglês
 * @returns {string} - Aba traduzida em português
 */
const translateTabFromInternal = (internalTab) => {
  return REVERSE_TAB_TRANSLATIONS[internalTab] || internalTab
}

/**
 * @deprecated
 * use the file relationships.js, which is more organized and complete.
*/

export const relationshipIsRecess = (id) => ([ 4, 11, 15, 16 ]).includes(id)

export const vacationHelpers = {
  translateFilterToBackend,
  translateFilterFromBackend,
  translateTabToInternal,
  translateTabFromInternal
}
